// Live coach OKR Plans paths (OKR_PLANS_COACH.md §8.2).
import { COACH_OKR_PLANS_BASE } from "../../../../data/RouteUrls";

export const dashboardPath = () => COACH_OKR_PLANS_BASE;
export const companyPath = (companyId, quarterCompanyId) =>
  `${COACH_OKR_PLANS_BASE}/companies/${companyId}${
    quarterCompanyId ? `?quarter=${quarterCompanyId}` : ""
  }`;
export const planPath = (planId) => `${COACH_OKR_PLANS_BASE}/plans/${planId}`;
export const reportPath = (planId, reportId) =>
  `${planPath(planId)}/reports/${reportId}`;
export const reviewPath = (planId) => `${planPath(planId)}/review`;
export const chatPath = (planId, chatId) =>
  `${planPath(planId)}/chats/${chatId}`;
